/* ==========================================================================
   DreamVapes Nebula — interactivity layer v4 (NEON RIBBON edition)
   - Neon ribbon trail: glowing comet line follows the cursor (desktop)
     and the finger (touch, while dragging)
   - Shockwave rings on tap/click — bigger ring + card pulse on products
   - Page transitions: glowing wipe when moving between pages / products
   - Cart ring burst, ripples, 3D card tilt (desktop), scroll reveals,
     progress bar, back-to-top, hero parallax, ambient drifting sparks
   Re-binds in the theme editor; respects prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

  /* ======================================================================
     NEON FX ENGINE — ribbon trail + shockwave rings + ambient sparks
     ====================================================================== */
  var FX = { ring: function () {} };
  var scrollEnergy = 0;

  var C1 = [124, 58, 237];   /* violet  */
  var C2 = [232, 121, 249];  /* fuchsia */
  function lerpColor(t, a) {
    var r = Math.round(C1[0] + (C2[0] - C1[0]) * t);
    var g = Math.round(C1[1] + (C2[1] - C1[1]) * t);
    var b = Math.round(C1[2] + (C2[2] - C1[2]) * t);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  }

  function initFxEngine() {
    if (reduceMotion || document.querySelector('.dv-cursor-fx')) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'dv-cursor-fx';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, coarsePointer ? 1.5 : 2);

    function resize() {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
    }
    resize();
    window.addEventListener('resize', resize);

    /* ---- flame trail particles ---- */
    var trail = [];
    var TRAIL_MAX = coarsePointer ? 70 : 110;
    var lastX = null, lastY = null, isDown = false;

    function pushPoint(x, y) {
      trail.push({
        x: x + (Math.random() - 0.5) * 4,
        y: y + (Math.random() - 0.5) * 4,
        life: 1,
        vx: (Math.random() - 0.5) * 0.5,
        vy: -(0.7 + Math.random() * 1.3),
        r: 3.5 + Math.random() * 5,
        seed: Math.random() * 100
      });
      if (trail.length > TRAIL_MAX) trail.shift();
    }

    /* trail: desktop mouse only — touch gets bursts, not a drag trail */
    if (finePointer) {
      document.addEventListener('pointermove', function (e) {
        if (lastX !== null) {
          var dx = e.clientX - lastX, dy = e.clientY - lastY;
          var dist = Math.sqrt(dx * dx + dy * dy);
          var steps = Math.min(Math.floor(dist / 7), 6);
          for (var i = 1; i <= steps; i++) {
            pushPoint(lastX + (dx * i) / steps, lastY + (dy * i) / steps);
            pushPoint(lastX + (dx * i) / steps, lastY + (dy * i) / steps);
          }
        }
        lastX = e.clientX; lastY = e.clientY;
      }, { passive: true });
    }

    document.addEventListener('pointerdown', function (e) {
      isDown = true;
      FX.ring(e.clientX, e.clientY, {});
      /* small flame burst on tap/click (desktop + mobile) */
      for (var i = 0; i < 6; i++) pushPoint(e.clientX, e.clientY);
    });
    document.addEventListener('pointerup', function () { isDown = false; });
    document.addEventListener('pointercancel', function () { isDown = false; });

    /* ---- shockwave rings ---- */
    var rings = [];
    FX.ring = function (x, y, opt) {
      opt = opt || {};
      rings.push({ x: x, y: y, r: opt.big ? 6 : 3, speed: opt.big ? 7 : 4.2, life: 1, big: !!opt.big });
      if (rings.length > 12) rings.shift();
    };

    /* ---- flame burst helper (age gate, gestures, parties) ---- */
    FX.flames = function (x, y, n) {
      for (var i = 0; i < (n || 12); i++) {
        pushPoint(x + (Math.random() - 0.5) * 60, y + (Math.random() - 0.5) * 24);
      }
    };

    /* ---- ambient drifting sparks ---- */
    var sparks = [];
    var SPARK_MAX = coarsePointer ? 14 : 22;
    var lastSpark = 0;
    function spawnSpark() {
      sparks.push({
        x: Math.random() * window.innerWidth,
        y: window.innerHeight * (0.5 + Math.random() * 0.55),
        vy: -0.12 - Math.random() * 0.2,
        r: 0.8 + Math.random() * 1.6,
        life: 1,
        decay: 0.0025 + Math.random() * 0.003,
        seed: Math.random() * 100,
        t: Math.random()
      });
      if (sparks.length > SPARK_MAX) sparks.shift();
    }

    (function loop(now) {
      requestAnimationFrame(loop);
      if (document.hidden) return;
      if (!now) now = 0;
      scrollEnergy *= 0.94;

      if (now - lastSpark > 380) { lastSpark = now; spawnSpark(); }

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      ctx.scale(dpr, dpr);
      ctx.globalCompositeOperation = 'lighter';

      /* ambient sparks */
      for (var s = sparks.length - 1; s >= 0; s--) {
        var sp = sparks[s];
        sp.y += sp.vy * (1 + scrollEnergy * 2);
        sp.x += Math.sin(sp.y * 0.01 + sp.seed) * 0.3;
        sp.life -= sp.decay;
        if (sp.life <= 0) { sparks.splice(s, 1); continue; }
        ctx.globalAlpha = sp.life * 0.5;
        ctx.fillStyle = lerpColor(sp.t, 1);
        ctx.shadowColor = lerpColor(sp.t, 0.9);
        ctx.shadowBlur = 8;
        ctx.beginPath();
        ctx.arc(sp.x, sp.y, sp.r, 0, Math.PI * 2);
        ctx.fill();
      }

      /* shockwave rings */
      for (var i = rings.length - 1; i >= 0; i--) {
        var rg = rings[i];
        rg.r += rg.speed;
        rg.life -= rg.big ? 0.03 : 0.045;
        if (rg.life <= 0) { rings.splice(i, 1); continue; }
        ctx.globalAlpha = 1;
        ctx.lineWidth = (rg.big ? 3.5 : 2.4) * rg.life;
        ctx.strokeStyle = lerpColor(0.5, rg.life * 0.9);
        ctx.shadowColor = lerpColor(0.5, 0.9);
        ctx.shadowBlur = 14 * rg.life;
        ctx.beginPath();
        ctx.arc(rg.x, rg.y, rg.r, 0, Math.PI * 2);
        ctx.stroke();
        if (rg.big) {
          ctx.lineWidth = 1.6 * rg.life;
          ctx.strokeStyle = lerpColor(0.9, rg.life * 0.6);
          ctx.beginPath();
          ctx.arc(rg.x, rg.y, rg.r * 0.66, 0, Math.PI * 2);
          ctx.stroke();
        }
      }

      /* flame trail — fire flickers rising behind the pointer */
      var nowMs2 = performance.now();
      for (var p = trail.length - 1; p >= 0; p--) {
        var f = trail[p];
        f.x += f.vx + Math.sin(nowMs2 * 0.02 + f.seed) * 0.45;  /* flicker */
        f.y += f.vy;
        f.vy *= 0.99;
        f.life -= 0.026 + Math.random() * 0.012;                /* uneven burn */
        if (f.life <= 0) { trail.splice(p, 1); continue; }

        var rr = f.r * f.life + 0.4;
        var col = f.life > 0.6 ? '255, 240, 220' : f.life > 0.3 ? '232, 121, 249' : '124, 58, 237';
        var fg = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, rr * 2.6);
        fg.addColorStop(0, 'rgba(' + col + ',' + f.life * 0.9 + ')');
        fg.addColorStop(1, 'rgba(' + col + ', 0)');
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
        ctx.fillStyle = fg;
        ctx.beginPath();
        ctx.arc(f.x, f.y, rr * 2.6, 0, Math.PI * 2);
        ctx.fill();
      }

      /* bright ember at the pointer tip */
      if (trail.length) {
        var tip = trail[trail.length - 1];
        ctx.globalAlpha = Math.min(tip.life + 0.3, 1);
        ctx.fillStyle = 'rgba(255, 250, 240, 0.95)';
        ctx.shadowColor = 'rgba(232, 121, 249, 1)';
        ctx.shadowBlur = 16;
        ctx.beginPath();
        ctx.arc(tip.x, tip.y, 2.4, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.restore();
    })(0);
  }

  /* scroll energy feeds the ambient sparks */
  var lastScrollY = window.scrollY;
  window.addEventListener('scroll', function () {
    var dy = Math.abs(window.scrollY - lastScrollY);
    lastScrollY = window.scrollY;
    scrollEnergy = Math.min(scrollEnergy + dy / 260, 2.5);
  }, { passive: true });

  /* ======================================================================
     PAGE TRANSITIONS — glowing wipe between pages / products
     ====================================================================== */
  var transitionsBound = false;
  function initPageTransitions() {
    if (transitionsBound) return;
    transitionsBound = true;

    /* arriving: fade the entry overlay away */
    if (document.documentElement.classList.contains('dv-pt-in')) {
      requestAnimationFrame(function () {
        setTimeout(function () {
          document.documentElement.classList.add('dv-pt-out');
          setTimeout(function () {
            document.documentElement.classList.remove('dv-pt-in', 'dv-pt-out');
          }, 700);
        }, 60);
      });
    }

    if (window.Shopify && Shopify.designMode) return; /* let the editor navigate normally */
    if (reduceMotion) return;

    var overlay = document.createElement('div');
    overlay.className = 'dv-page-transition';
    overlay.innerHTML = '<div class="dv-pt-glow"></div>';
    document.body.appendChild(overlay);

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || a.target || a.hasAttribute('download')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/.test(href)) return;
      var url;
      try { url = new URL(href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;

      e.preventDefault();

      /* product click: the card lifts out from the rest before the wipe */
      var item = a.closest('.grid__item, li, .card-wrapper, .collection-list__item');
      if (item) {
        var grid = item.parentElement;
        if (grid) grid.classList.add('dv-has-standout');
        item.classList.add('dv-standout-item');
        FX.ring(e.clientX, e.clientY, { big: true });
        setTimeout(function () { FX.ring(e.clientX, e.clientY, {}); }, 120);
      }

      overlay.classList.add('dv-active');
      try { sessionStorage.setItem('dv-pt', '1'); } catch (err) {}
      setTimeout(function () { location.href = url.href; }, item ? 520 : 400);
    });
  }

  /* ======================================================================
     Scroll progress bar + back-to-top
     ====================================================================== */
  function initChrome() {
    if (document.querySelector('.dv-scroll-progress')) return;

    var bar = document.createElement('div');
    bar.className = 'dv-scroll-progress';
    document.body.appendChild(bar);

    var topBtn = document.createElement('button');
    topBtn.className = 'dv-back-to-top';
    topBtn.type = 'button';
    topBtn.setAttribute('aria-label', 'Back to top');
    topBtn.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    document.body.appendChild(topBtn);

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight;
        bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
        topBtn.classList.toggle('dv-visible', h.scrollTop > 600);
        parallax(h.scrollTop);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ======================================================================
     Hero parallax
     ====================================================================== */
  function parallax(y) {
    if (reduceMotion) return;
    var media = document.querySelector('.banner__media, .slideshow__media');
    if (!media) return;
    var r = media.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    media.style.transform = 'translateY(' + Math.min(y * 0.12, 80) + 'px)';
  }

  /* ======================================================================
     Reveal on scroll
     ====================================================================== */
  var revealSelector = [
    '.card-wrapper', '.collection-list__item', '.multicolumn-card',
    '.image-with-text__content', '.image-with-text__media',
    '.rich-text__wrapper', '.banner__content', '.slideshow__text-wrapper',
    '.multirow__row', '.collage__item', '.title-wrapper-with-link', '.footer-block'
  ].join(',');
  var io = null;

  function initReveal(scope) {
    if (reduceMotion) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('dv-revealed');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    }
    (scope || document).querySelectorAll(revealSelector).forEach(function (el, i) {
      if (el.classList.contains('dv-reveal')) return;
      el.classList.add('dv-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ======================================================================
     Spotlight glow follows the cursor across cards (desktop)
     (flat — no perspective tilt; lift + glow come from CSS hover)
     ====================================================================== */
  function initTilt(scope) {
    if (reduceMotion || !finePointer) return;
    (scope || document).querySelectorAll('.card-wrapper .card').forEach(function (card) {
      if (card.dataset.dvTilt) return;
      card.dataset.dvTilt = '1';
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--dv-mx', ((e.clientX - r.left) / r.width) * 100 + '%');
        card.style.setProperty('--dv-my', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  /* ======================================================================
     Tap / click ripples
     ====================================================================== */
  var rippleBound = false;
  function initRipple() {
    if (reduceMotion || rippleBound) return;
    rippleBound = true;
    document.addEventListener('pointerdown', function (e) {
      var host = e.target.closest(
        '.button, .card__inner, .card, .header__icon, .dv-back-to-top, .collection-list__item, [role="button"]'
      );
      if (!host) return;
      var r = host.getBoundingClientRect();
      var d = Math.max(r.width, r.height) * 1.1;
      var rip = document.createElement('span');
      rip.className = 'dv-ripple';
      rip.style.width = rip.style.height = d + 'px';
      rip.style.left = (e.clientX - r.left - d / 2) + 'px';
      rip.style.top = (e.clientY - r.top - d / 2) + 'px';
      host.appendChild(rip);
      setTimeout(function () { rip.remove(); }, 700);
    }, { passive: true });
  }

  /* ======================================================================
     Cart ring burst + icon pop
     ====================================================================== */
  function initCartPop() {
    var bubble = document.querySelector('cart-icon-bubble, #cart-icon-bubble');
    if (!bubble || bubble.dataset.dvPop) return;
    bubble.dataset.dvPop = '1';
    var last = bubble.textContent;
    new MutationObserver(function () {
      if (bubble.textContent === last) return;
      last = bubble.textContent;
      bubble.classList.remove('dv-pop');
      void bubble.offsetWidth;
      bubble.classList.add('dv-pop');
      var r = bubble.getBoundingClientRect();
      FX.ring(r.left + r.width / 2, r.top + r.height / 2, { big: true });
      setTimeout(function () {
        FX.ring(r.left + r.width / 2, r.top + r.height / 2, {});
      }, 150);
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* ======================================================================
     Hero heading glow
     ====================================================================== */
  function initHeroFx(scope) {
    (scope || document).querySelectorAll('.banner__heading, .slideshow__text .banner__heading').forEach(function (h) {
      h.classList.add('dv-hero-heading');
    });
  }

  /* ======================================================================
     TOAST helper
     ====================================================================== */
  var toastEl = null;
  function dvToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'dv-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('dv-toast--show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('dv-toast--show'); }, 2600);
  }

  /* ======================================================================
     PARTY helper — flame fountain + ring volley
     ====================================================================== */
  function dvParty(x, y, msg) {
    var cx = x == null ? window.innerWidth / 2 : x;
    var cy = y == null ? window.innerHeight * 0.6 : y;
    var n = 0;
    var iv = setInterval(function () {
      FX.flames(cx + (Math.random() - 0.5) * 160, cy + (Math.random() - 0.5) * 60, 10);
      FX.ring(cx, cy, { big: n % 2 === 0 });
      if (++n >= 7) clearInterval(iv);
    }, 100);
    if (msg) dvToast(msg);
  }

  /* ======================================================================
     AGE VERIFICATION — interactive & fun
     ====================================================================== */
  function initAgeGate() {
    try { if (localStorage.getItem('dv-age-ok') === 'yes') return; } catch (e) {}
    if (document.querySelector('.dv-agegate')) return;

    var gate = document.createElement('div');
    gate.className = 'dv-agegate';
    gate.setAttribute('role', 'dialog');
    gate.setAttribute('aria-modal', 'true');
    gate.innerHTML =
      '<div class="dv-agegate__card">' +
        '<div class="dv-agegate__logo">DREAM VAPES</div>' +
        '<p class="dv-agegate__sub">This store sells vaping products intended for adults.</p>' +
        '<h2 class="dv-agegate__q">Are you 19 or older?</h2>' +
        '<div class="dv-agegate__actions">' +
          '<button type="button" class="dv-agegate__btn dv-agegate__yes">Yes, I am 19+</button>' +
          '<button type="button" class="dv-agegate__btn dv-agegate__no">Not yet</button>' +
        '</div>' +
        '<p class="dv-agegate__note">You must be of legal vaping age in your province or territory to enter.</p>' +
      '</div>';
    document.body.appendChild(gate);
    document.body.classList.add('dv-agegate-open');

    var card = gate.querySelector('.dv-agegate__card');
    var yes = gate.querySelector('.dv-agegate__yes');
    var no = gate.querySelector('.dv-agegate__no');

    requestAnimationFrame(function () { gate.classList.add('dv-agegate--in'); });

    /* the "Not yet" button playfully squirms (stays clickable) */
    no.addEventListener('pointerenter', function () {
      var dx = (Math.random() - 0.5) * 14;
      var dy = (Math.random() - 0.5) * 10;
      no.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
    });

    /* flames lick off the YES button on hover */
    yes.addEventListener('pointerenter', function () {
      var r = yes.getBoundingClientRect();
      FX.flames(r.left + r.width / 2, r.top, 8);
    });

    yes.addEventListener('click', function () {
      var r = yes.getBoundingClientRect();
      var n = 0;
      var iv = setInterval(function () {
        FX.flames(r.left + Math.random() * r.width, r.top, 10);
        FX.ring(r.left + r.width / 2, r.top + r.height / 2, { big: n % 2 === 0 });
        if (++n >= 6) clearInterval(iv);
      }, 90);
      yes.classList.add('dv-agegate__yes--party');
      try { localStorage.setItem('dv-age-ok', 'yes'); } catch (e) {}
      setTimeout(function () {
        card.classList.add('dv-agegate__card--bye');
        gate.classList.add('dv-agegate--out');
        document.body.classList.remove('dv-agegate-open');
        dvToast('Welcome to Dream Vapes');
        setTimeout(function () { gate.remove(); }, 700);
      }, 650);
    });

    no.addEventListener('click', function () {
      card.classList.remove('dv-agegate__card--shake');
      void card.offsetWidth;
      card.classList.add('dv-agegate__card--shake');
      gate.querySelector('.dv-agegate__q').textContent = 'Sorry — you must be 19 or older to enter.';
      gate.querySelector('.dv-agegate__actions').innerHTML =
        '<a class="dv-agegate__btn dv-agegate__yes" href="https://www.canada.ca/en/health-canada/services/smoking-tobacco/vaping.html" rel="noopener">Learn about vaping &amp; health</a>';
    });
  }

  /* ======================================================================
     BUY BUTTON CELEBRATIONS — Add to cart / Buy now / Checkout
     ====================================================================== */
  var flashEl = null;
  function dvFlash() {
    if (!flashEl) {
      flashEl = document.createElement('div');
      flashEl.className = 'dv-flash';
      document.body.appendChild(flashEl);
    }
    flashEl.classList.remove('dv-flash--go');
    void flashEl.offsetWidth;
    flashEl.classList.add('dv-flash--go');
  }

  function celebrateAt(el, big, msg) {
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var n = 0;
    var iv = setInterval(function () {
      FX.flames(cx + (Math.random() - 0.5) * r.width, r.top, big ? 12 : 8);
      if (big || n % 2 === 0) FX.ring(cx, cy, { big: big });
      if (++n >= (big ? 6 : 4)) clearInterval(iv);
    }, 90);
    if (big) dvFlash();
    if (msg) dvToast(msg);
  }

  var buyFxBound = false;
  function initBuyFx() {
    if (reduceMotion || buyFxBound) return;
    buyFxBound = true;

    document.addEventListener('click', function (e) {
      /* Add to cart */
      var addBtn = e.target.closest('.product-form__submit, form[action*="/cart/add"] button[type="submit"]');
      if (addBtn && !addBtn.disabled) {
        celebrateAt(addBtn, false, 'Nice pick — adding to your cart!');
        return;
      }

      /* Buy it now (dynamic checkout) */
      var buyBtn = e.target.closest('.shopify-payment-button');
      if (buyBtn) {
        celebrateAt(buyBtn, true, 'Great choice — off you go!');
        return;
      }

      /* Checkout (cart page + cart drawer) */
      var checkoutBtn = e.target.closest('.cart__checkout-button, button[name="checkout"], a[href*="/checkout"]');
      if (checkoutBtn) {
        celebrateAt(checkoutBtn, true, 'Almost yours — let\'s check out!');
      }
    });
  }

  /* ======================================================================
     FREE LOCAL DELIVERY progress bar (cart drawer + cart page)
     ------------------------------------------------------------------
     DV_FREE_SHIP_CENTS: free-delivery minimum in cents.
     10000 = $100.00 — change this one number to match your threshold.
     ====================================================================== */
  var DV_FREE_SHIP_CENTS = 10000;

  function initFreeShip() {
    var unlocked = false;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function buildWidget() {
      var w = document.createElement('div');
      w.className = 'dv-freeship';
      w.innerHTML =
        '<p class="dv-freeship__text"></p>' +
        '<div class="dv-freeship__track"><div class="dv-freeship__fill"></div></div>';
      /* inline fallbacks so the bar shows even if CSS is overridden/cached */
      var track = w.querySelector('.dv-freeship__track');
      track.style.display = 'block'; /* base.css hides div:empty */
      track.style.height = '8px';
      track.style.borderRadius = '8px';
      track.style.background = 'rgba(255,255,255,0.10)';
      track.style.overflow = 'hidden';
      var fill = w.querySelector('.dv-freeship__fill');
      fill.style.display = 'block'; /* base.css hides div:empty */
      fill.style.height = '100%';
      fill.style.borderRadius = '8px';
      fill.style.background = 'linear-gradient(90deg,#7c3aed,#c026d3,#e879f9)';
      fill.style.boxShadow = '0 0 12px rgba(192,38,211,0.7)';
      fill.style.transition = 'width 0.6s cubic-bezier(0.22,1,0.36,1)';
      fill.style.width = '0%';
      return w;
    }

    function place() {
      var drawerInner = document.querySelector('cart-drawer .drawer__inner');
      if (drawerInner && !drawerInner.querySelector('.dv-freeship')) {
        var w = buildWidget();
        var header = drawerInner.querySelector('.drawer__header');
        if (header && header.nextSibling) drawerInner.insertBefore(w, header.nextSibling);
        else drawerInner.insertBefore(w, drawerInner.firstChild);
      }
      var cartForm = document.querySelector('form#cart');
      if (cartForm && !document.querySelector('.dv-freeship--page')) {
        var pw = buildWidget();
        pw.classList.add('dv-freeship--page');
        cartForm.parentNode.insertBefore(pw, cartForm);
      }
    }

    function refresh() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          place();
          document.querySelectorAll('.dv-freeship').forEach(function (w) {
            var text = w.querySelector('.dv-freeship__text');
            var fill = w.querySelector('.dv-freeship__fill');
            if (!cart.item_count) {
              w.style.display = 'none';
              unlocked = false;
              return;
            }
            w.style.display = '';
            var pct = Math.min(cart.total_price / DV_FREE_SHIP_CENTS, 1) * 100;
            var wPct = pct + '%';
            /* set width directly — the CSS transition animates cart changes.
               (no rAF timing tricks: those could leave the bar stuck empty) */
            if (fill.style.width !== wPct) fill.style.width = wPct;
            w.dataset.dvPct = wPct;
            if (cart.total_price >= DV_FREE_SHIP_CENTS) {
              w.classList.add('dv-freeship--unlocked');
              var unlockedText = '<strong>FREE Canada-wide delivery unlocked!</strong>';
              if (text.innerHTML !== unlockedText) text.innerHTML = unlockedText;
              if (!unlocked) {
                unlocked = true;
                var r = w.getBoundingClientRect();
                FX.flames(r.left + r.width / 2, r.top + r.height / 2, 14);
                FX.ring(r.left + r.width / 2, r.top + r.height / 2, { big: true });
                dvToast('Free Canada-wide delivery unlocked!');
              }
            } else {
              w.classList.remove('dv-freeship--unlocked');
              var awayText =
                'You\'re <strong>' + money(DV_FREE_SHIP_CENTS - cart.total_price) +
                '</strong> away from <strong>FREE Canada-wide delivery</strong>';
              if (text.innerHTML !== awayText) text.innerHTML = awayText;
            }
          });
        })
        .catch(function () {});
    }

    /* refresh after any cart mutation (wrap fetch once) */
    if (!window.__dvFetchWrapped) {
      window.__dvFetchWrapped = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var p = origFetch.apply(this, arguments);
        var first = arguments[0];
        var url = String((first && first.url) || first || '');
        if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 ||
            url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1) {
          p.then(function () { setTimeout(refresh, 350); }).catch(function () {});
        }
        return p;
      };
    }

    /* Ride/Dawn re-renders the cart drawer AND the cart page section after
       every cart change — watch both and re-place + re-fill the widget */
    function watchCartRegion(el) {
      if (!el || el.dataset.dvFsObs) return;
      el.dataset.dvFsObs = '1';
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(refresh, 150);
      }).observe(el, { childList: true, subtree: true });
    }
    watchCartRegion(document.querySelector('cart-drawer'));
    watchCartRegion(document.getElementById('shopify-section-main-cart-items'));
    watchCartRegion(document.querySelector('main-cart-items'));

    refresh();
  }

  /* ======================================================================
     STORE LOCATIONS — header pin button + map modal
     ====================================================================== */
  var DV_STORES = [
    { name: 'Dream Vapes Castlegar', address: '1780 Columbia Ave, Unit B, Castlegar, BC V1N 2W5' },
    { name: 'Dream Vapes Nelson', address: '301 Nelson Ave, Nelson, BC V1L 3Y1', ll: '49.5001339,-117.279772' }, /* pinned by exact coordinates from the Google Maps business listing */
    { name: 'Dream Vapes Trail', address: '1020 Farwell St, Trail, BC V1R 3V3' },
    { name: 'Dream Vapes Castlegar Downtown', address: '1010 3rd St, Castlegar, BC V1N 4G3' },
    { name: 'Dream Vapes Prince George', address: '4293 5th Ave, Prince George, BC V2M 6Y4' },
    { name: 'Dream Vapes Niagara Falls', address: '4790 Dorchester Rd, Niagara Falls, ON L2E 6N9' }
  ];

  var locModal = null;

  function openLocationsModal() {
    if (locModal) return;
    locModal = document.createElement('div');
    locModal.className = 'dv-locmodal';
    locModal.setAttribute('role', 'dialog');
    locModal.setAttribute('aria-modal', 'true');

    var cardsHtml = DV_STORES.map(function (s, i) {
      /* map pin: exact coordinates win; otherwise business name + address.
         directions: always business name + address so Google routes to the
         store listing itself and shows its name */
      var q = encodeURIComponent(s.ll || (s.name + ', ' + s.address));
      var dirQ = encodeURIComponent(s.name + ', ' + s.address);
      return (
        '<button type="button" class="dvloc-card' + (i === 0 ? ' is-active' : '') + '" data-map="https://www.google.com/maps?q=' + q + '&output=embed">' +
          '<span class="dvloc-card__name">' + s.name + '</span>' +
          '<span class="dvloc-card__address">' + s.address + '</span>' +
          '<span class="dvloc-card__links">' +
            '<span class="dvloc-card__view">View on map</span>' +
            '<a class="dvloc-card__directions" href="https://www.google.com/maps/dir/?api=1&destination=' + dirQ + '" target="_blank" rel="noopener" onclick="event.stopPropagation()">Get directions</a>' +
          '</span>' +
        '</button>'
      );
    }).join('');

    var q0 = encodeURIComponent(DV_STORES[0].ll || (DV_STORES[0].name + ', ' + DV_STORES[0].address));
    locModal.innerHTML =
      '<div class="dv-locmodal__card">' +
        '<button type="button" class="dv-locmodal__close" aria-label="Close locations">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<h2 class="dv-locmodal__title">Visit Our Stores</h2>' +
        '<p class="dv-locmodal__sub">Six locations across BC and Ontario — tap a store to see it on the map.</p>' +
        '<div class="dvloc__layout">' +
          '<div class="dvloc__list">' + cardsHtml + '</div>' +
          '<div class="dvloc__map"><iframe src="https://www.google.com/maps?q=' + q0 + '&output=embed" title="Store map" loading="lazy" allowfullscreen style="border:0"></iframe></div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(locModal);
    document.body.classList.add('dv-locmodal-open');

    var frame = locModal.querySelector('iframe');
    locModal.querySelectorAll('.dvloc-card').forEach(function (card) {
      card.addEventListener('click', function () {
        locModal.querySelectorAll('.dvloc-card').forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        var src = card.getAttribute('data-map');
        if (frame.getAttribute('src') !== src) {
          frame.style.opacity = '0';
          frame.addEventListener('load', function onload() {
            frame.removeEventListener('load', onload);
            frame.style.opacity = '1';
          });
          setTimeout(function () { frame.setAttribute('src', src); }, 200);
        }
      });
    });

    function close() {
      locModal.classList.remove('dv-locmodal--in');
      document.body.classList.remove('dv-locmodal-open');
      var m = locModal;
      locModal = null;
      setTimeout(function () { m.remove(); }, 380);
      document.removeEventListener('keydown', onEsc);
    }
    function onEsc(e) { if (e.key === 'Escape') close(); }

    locModal.querySelector('.dv-locmodal__close').addEventListener('click', close);
    locModal.addEventListener('click', function (e) { if (e.target === locModal) close(); });
    document.addEventListener('keydown', onEsc);
    requestAnimationFrame(function () { locModal.classList.add('dv-locmodal--in'); });
  }

  function initHeaderLocations() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.header__icon--locations')) return;
    var btn = document.createElement('button');
    btn.className = 'header__icon header__icon--locations link focus-inset';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Store locations');
    btn.title = 'Store locations';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-5.6-7-11a7 7 0 1 1 14 0c0 5.4-7 11-7 11Z"/><circle cx="12" cy="10" r="2.6"/></svg>';
    icons.insertBefore(btn, icons.firstChild);
    btn.addEventListener('click', function (e) {
      FX.ring(e.clientX, e.clientY, {});
      openLocationsModal();
    });
  }

  /* ======================================================================
     FUN GESTURES — wiggle, shake, long-press, secret word
     ====================================================================== */
  var gesturesBound = false;
  function initGestures() {
    if (reduceMotion || gesturesBound) return;
    gesturesBound = true;

    /* 1. mouse wiggle = desktop shake */
    if (finePointer) {
      var pts = [];
      document.addEventListener('pointermove', function (e) {
        var now = performance.now();
        pts.push({ x: e.clientX, t: now });
        while (pts.length && now - pts[0].t > 700) pts.shift();
        var flips = 0;
        for (var i = 2; i < pts.length; i++) {
          var d1 = pts[i - 1].x - pts[i - 2].x;
          var d2 = pts[i].x - pts[i - 1].x;
          if (d1 !== 0 && d2 !== 0 && (d1 > 0) !== (d2 > 0) && Math.abs(d1) > 12 && Math.abs(d2) > 12) flips++;
        }
        if (flips >= 5) {
          pts = [];
          dvParty(e.clientX, e.clientY, 'Nice moves!');
        }
      }, { passive: true });
    }

    /* 2. phone shake */
    var lastShake = 0;
    window.addEventListener('devicemotion', function (e) {
      var a = e.accelerationIncludingGravity;
      if (!a || a.x == null) return;
      var mag = Math.sqrt(a.x * a.x + a.y * a.y + a.z * a.z);
      if (mag > 28 && performance.now() - lastShake > 2000) {
        lastShake = performance.now();
        dvParty(null, null, 'You shook things up!');
      }
    });

    /* 3. long-press a product card = secret flip */
    var lpTimer = null;
    document.addEventListener('pointerdown', function (e) {
      var wrap = e.target.closest('.card-wrapper, .collection-list__item');
      if (!wrap) return;
      lpTimer = setTimeout(function () {
        var r = wrap.getBoundingClientRect();
        wrap.classList.add('dv-flip');
        dvParty(r.left + r.width / 2, r.top + r.height / 2, 'You found a secret move!');
        setTimeout(function () { wrap.classList.remove('dv-flip'); }, 950);
        var stop = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          document.removeEventListener('click', stop, true);
        };
        document.addEventListener('click', stop, true);
      }, 650);
    });
    ['pointerup', 'pointermove', 'pointercancel'].forEach(function (ev) {
      document.addEventListener(ev, function () { clearTimeout(lpTimer); }, { passive: true });
    });

    /* 4. type the secret word "dream" */
    var typed = '';
    document.addEventListener('keydown', function (e) {
      var tag = (e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
      typed = (typed + String(e.key).toLowerCase()).slice(-5);
      if (typed === 'dream') {
        typed = '';
        dvParty(null, null, 'Sweet dreams — you found the secret word');
      }
    });
  }

  /* ======================================================================
     AMBIENT SMOKE — soft violet smoke puffs drifting bottom → top
     Sits on its own fixed canvas (pointer-events: none, screen blend),
     below the header/drawers, above the section paint.
     ====================================================================== */
  function initSmoke() {
    if (reduceMotion || document.getElementById('dv-smoke')) return;

    var canvas = document.createElement('canvas');
    canvas.id = 'dv-smoke';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var W = 0, H = 0;

    function resize() {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
    }
    resize();
    window.addEventListener('resize', resize);

    /* pre-render soft puff sprites in the theme hues */
    function makeSprite(r, g, b) {
      var s = document.createElement('canvas');
      s.width = s.height = 256;
      var x = s.getContext('2d');
      var grad = x.createRadialGradient(128, 128, 0, 128, 128, 128);
      grad.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',0.55)');
      grad.addColorStop(0.35, 'rgba(' + r + ',' + g + ',' + b + ',0.22)');
      grad.addColorStop(0.7, 'rgba(' + r + ',' + g + ',' + b + ',0.06)');
      grad.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
      x.fillStyle = grad;
      x.fillRect(0, 0, 256, 256);
      return s;
    }
    var sprites = [
      makeSprite(124, 58, 237),   /* violet  */
      makeSprite(168, 85, 247),   /* purple  */
      makeSprite(192, 38, 211)    /* fuchsia */
    ];

    var COUNT = window.innerWidth < 750 ? 8 : 14;
    var puffs = [];

    function spawn(p, fromBottom) {
      p.sprite = sprites[(Math.random() * sprites.length) | 0];
      p.r = 90 + Math.random() * 170;            /* radius, css px */
      p.x = Math.random() * W;
      p.y = fromBottom ? H + p.r : Math.random() * (H + p.r);
      p.vy = 0.18 + Math.random() * 0.30;        /* rise speed */
      p.grow = 0.03 + Math.random() * 0.05;      /* expands as it rises */
      p.sway = Math.random() * Math.PI * 2;
      p.swaySpd = 0.004 + Math.random() * 0.006;
      p.swayAmp = 24 + Math.random() * 46;
      p.maxA = 0.11 + Math.random() * 0.08;      /* peak opacity */
      p.life = 0;
    }
    for (var i = 0; i < COUNT; i++) {
      var p0 = {};
      spawn(p0, false);
      p0.life = Math.random();                   /* stagger fade-in */
      puffs.push(p0);
    }

    function frame() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < puffs.length; i++) {
        var p = puffs[i];
        p.life = Math.min(1, p.life + 0.004);
        p.y -= p.vy;
        p.r += p.grow;
        p.sway += p.swaySpd;
        if (p.y < -p.r * 1.3) { spawn(p, true); continue; }
        var x = p.x + Math.sin(p.sway) * p.swayAmp;
        /* fade in with life, fade out near the top of the screen */
        var fadeTop = Math.min(1, Math.max(0, (p.y + p.r) / (H * 0.45)));
        ctx.globalAlpha = p.maxA * p.life * fadeTop;
        ctx.drawImage(p.sprite, (x - p.r) * dpr, (p.y - p.r) * dpr, p.r * 2 * dpr, p.r * 2 * dpr);
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ======================================================================
     SECTION ORBS — tiny glowing motes + soft big orbs floating upward
     in the gaps between homepage sections (zero layout impact)
     ====================================================================== */
  function initSectionOrbs() {
    if (reduceMotion) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = main.children;
    for (var i = 1; i < sections.length; i++) {
      var sec = sections[i];
      if (!sec.classList || !sec.classList.contains('shopify-section')) continue;
      var prev = sec.previousElementSibling;
      if (prev && prev.classList.contains('dv-orbdivider')) continue;

      var d = document.createElement('div');
      d.className = 'dv-orbdivider';
      d.setAttribute('aria-hidden', 'true');

      var small = window.innerWidth < 750 ? 5 : 8;
      for (var j = 0; j < small; j++) {
        var dot = document.createElement('i');
        dot.style.setProperty('--x', (6 + Math.random() * 88).toFixed(1) + '%');
        dot.style.setProperty('--s', (4 + Math.random() * 6).toFixed(1) + 'px');
        dot.style.setProperty('--d', (7 + Math.random() * 7).toFixed(1) + 's');
        dot.style.setProperty('--dl', (-Math.random() * 12).toFixed(1) + 's');
        dot.style.setProperty('--sx', ((Math.random() - 0.5) * 60).toFixed(0) + 'px');
        dot.style.setProperty('--o', (0.45 + Math.random() * 0.4).toFixed(2));
        d.appendChild(dot);
      }
      /* a couple of big soft glow orbs for depth */
      var big = window.innerWidth < 750 ? 1 : 2;
      for (var k = 0; k < big; k++) {
        var orb = document.createElement('b');
        orb.style.setProperty('--x', (12 + Math.random() * 76).toFixed(1) + '%');
        orb.style.setProperty('--s', (26 + Math.random() * 30).toFixed(1) + 'px');
        orb.style.setProperty('--d', (11 + Math.random() * 6).toFixed(1) + 's');
        orb.style.setProperty('--dl', (-Math.random() * 14).toFixed(1) + 's');
        orb.style.setProperty('--sx', ((Math.random() - 0.5) * 90).toFixed(0) + 'px');
        orb.style.setProperty('--o', (0.18 + Math.random() * 0.12).toFixed(2));
        d.appendChild(orb);
      }
      main.insertBefore(d, sec);
    }
  }

  function initAll(scope) {
    initFxEngine();
    initSmoke();
    initSectionOrbs();
    initAgeGate();
    initPageTransitions();
    initChrome();
    initReveal(scope);
    initTilt(scope);
    initRipple();
    initCartPop();
    initHeroFx(scope);
    initBuyFx();
    initFreeShip();
    initHeaderLocations();
    initGestures();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
